/**
 * Created by sung on 2017-02-07.
 */
import {Component, OnInit, ElementRef, Directive, AfterContentInit, Attribute} from '@angular/core';
import {NgModule} from '@angular/core';
import {SelectItem} from 'primeng/primeng';
import { DataTableModule, SharedModule,PaginatorModule,DropdownModule,InputTextModule, ButtonModule, PanelModule} from 'primeng/primeng';
import {MamAdminService} from '../../service/mam_service.component';


import {FormsModule} from "@angular/forms";
import {HttpModule} from "@angular/http";
import {BrowserModule} from "@angular/platform-browser";

import {CommonModule, DatePipe} from "@angular/common";
import {TranslateServiceForm, TranslatePipeMoudle} from "../../translate";
import {SearchDropBoxModule} from "../../component/search_dropbox.component";
import {MainPipeMoudle} from "../../pipe/main.pipe";
import {Logger, Options, Level } from "angular2-logger/core"; // ADD THIS
import {ExDialogModule} from "../../component/dialog.component";
import {MessageUtil, StringUtil, LogConvertPipeMoudle} from "../../utility";



@Component({

  selector: 'hb_log',
  templateUrl: 'heartbeat_log.html'
})

export class HeartBeatLogComponent implements OnInit {

  totalRecord: number;
  searchIDs: SelectItem[];
  table_list: any;

  dateIsTrue : boolean;

  searchIsTrue : boolean;
  excelIsTrue : boolean = true;
  sDate: string;
  eDate: string;

  searchText: string;
  searchId : string;

  isLike : string;
  pageMax:number =10;
  curPage:number = 0;
  date : Date= new Date();
  datePipe : any = new DatePipe("en");

  searchTextDropBox : SelectItem[];
  searchTextIsDropBox : boolean;
  searchTextIsUse : boolean;

  severity_items : SelectItem[];
  status_items : SelectItem[];
  message_items : SelectItem[];

  private isVisible : boolean = false;
  private title : string;
  private dialogWidth : any;

  public detailLog : any;

  private translate:TranslateServiceForm;

  private messageUtil: MessageUtil;

  private severity : string;
  private message : string;
  private result : string;
  private sourceType : string;
  private status : string;

  private issuedTitle : string;
  private isIssuedVisible : boolean = false;
  private dialogIssuedWidth : any;

  private issueID : string;
  private issueMessage : string;

  ngOnInit() {
    this.searchTextIsUse = false;

    let nDate = new Date();
    nDate.setDate(nDate.getDate()-15);

    this.sDate = this.datePipe.transform(nDate, 'yyyy-MM-dd');
    this.eDate = this.datePipe.transform(this.date, 'yyyy-MM-dd');

    this.getMdmLogList(0,10, "", "", this.sDate, this.eDate);
    this.getMessageGroup();
    
    this.dialogWidth = 600;
    this.dialogIssuedWidth = 500;

  }

  constructor(private service : MamAdminService, private _translate: TranslateServiceForm, private logger : Logger) {
    this.translate = _translate;
    this.searchIDs = [];
    this.searchIDs.push({label: '---------------', value: 'all'});
    this.searchIDs.push({label: this.translate.instant('LANG_severity'), value: 'severity'});
    this.searchIDs.push({label: this.translate.instant('DeviceUser'), value: 'username'});
    this.searchIDs.push({label: this.translate.instant('LANG_logStatus'), value: 'status'});
    this.searchIDs.push({label: this.translate.instant('LANG_logMessage'), value: 'message'});

    this.severity_items = [];
    this.severity_items.push({label: '---------------', value: 'all'});
    this.severity_items.push({label: this.translate.instant('Severity_INFO'), value: 'INFO'});
    this.severity_items.push({label: this.translate.instant('Severity_WARN'), value: 'WARN'});
    this.severity_items.push({label: this.translate.instant('Severity_FATAL'), value: 'FATAL'});

    this.status_items = [];
    this.status_items.push({label: '---------------', value: 'all'});
    this.status_items.push({label: this.translate.instant('Status_OPENED'), value: 'OPENED'});
    this.status_items.push({label: this.translate.instant('Status_FIXED'), value: 'FIXED'});
    this.status_items.push({label: this.translate.instant('Status_CLOSED'), value: 'CLOSED'});

    this.message_items = [];
    this.status_items.push({label: '---------------', value: 'all'});

    this.dateIsTrue = true;

    this.title = this.translate.instant('LANG_LOG_IssueLog');
    this.messageUtil = new MessageUtil(_translate);
  }

  getSearchModel(event){
    this.logger.debug("event : ",event);
    this.searchIsTrue = event.searchIsTrue;
    this.searchText = event.searchText;
    this.sDate = event.sDate;
    this.eDate = event.eDate;
    this.searchId = event.searchId;
    this.logger.debug(this.searchId)

    if(this.searchId == 'severity' || this.searchId == 'status') {
      this.isLike = "false";
    }
    this.logger.debug(this.sDate);
    if(!this.sDate || !this.eDate ) {
      alert(this.translate.instant('MESSAGE_SearchDate_Require'));
      return;
    }

    if(this.eDate < this.sDate ) {
      alert(this.translate.instant('MESSAGE_LastDate_Less_StartDate'));
      return;
    }

    this.getMdmLogList(0,this.pageMax,this.searchText, this.searchId, this.sDate, this.eDate);

  }

  paginate(event) {
    this.pageMax = event.rows;
    this.curPage = event.page;
    if (this.searchIsTrue) {
      this.getMdmLogList(event.page, event.rows,this.searchText, this.searchId, this.sDate, this.eDate);
    } else {
      let nDate = new Date();
      nDate.setDate(nDate.getDate()-15);
      this.getMdmLogList(event.page, event.rows,"", "",this.datePipe.transform(nDate, 'yyyy-MM-dd'),this.datePipe.transform(this.date, 'yyyy-MM-dd'));
    }

  }

  getMdmLogList(page:number, max:number, search:string, field:string, start:string, end:string){
    this.service.getMdmLogList(page, max, search, field, start, end).subscribe(
        value => {
            this.table_list = value.content;
            this.totalRecord = value.totalElements;
        },
        error=>{this.logger.error("-- error : " + error);},
        ()=>{}
    )
  }

  getMessageGroup() {
    this.service.getMessageGroup().subscribe(
        value => {
          this.logger.debug(value);
        },
        error=>{this.logger.error("-- error : " + error);},
        ()=>{}
    )
  }


  searchTextChange(data) {
    this.logger.debug("data => ", data);
    if(data == 'severity') {
      this.searchTextDropBox = this.severity_items;
      this.searchTextIsUse = false;
      this.searchTextIsDropBox = true;
    } else if(data == 'status') {
      this.searchTextDropBox = this.status_items;
      this.searchTextIsUse = false;
      this.searchTextIsDropBox = true;
    } else if(data == 'message') {
      this.searchTextIsDropBox = true;
      this.searchTextDropBox = this.message_items;
      this.searchTextIsUse = false;
    } else if(data == 'all' || !data) {
      this.searchTextIsUse = false;
      this.searchTextIsDropBox = false;
    } else {
      this.searchTextIsUse = true;
      this.searchTextIsDropBox = false;
    }


  }

  excelExport(event){
    this.logger.debug(event);
    this.logger.debug(this.sDate);
    this.logger.debug(this.eDate);
    if(!this.sDate || !this.eDate) {
      alert(this.translate.instant('MESSAGE_Search_And_Out'));
      return;
    }
    var url = this.service.getUrl() + "/mgr/log/issue/excel";
    this.logger.debug(this.searchId);

    if(!this.searchId || this.searchId == "all") {
      url = url + "?start=" + this.datePipe.transform(this.sDate, 'yyyy-MM-dd') + "&end=" + this.datePipe.transform(this.eDate, 'yyyy-MM-dd');
    } else{
      url = url + "?start=" + this.datePipe.transform(this.sDate, 'yyyy-MM-dd') + "&end=" + this.datePipe.transform(this.eDate, 'yyyy-MM-dd') +
      "&search_text=" + this.searchText + "&search_field=" + this.searchId;
    }
    window.open(url);
  }


  detailIssueLog(rowData) {
    this.detailLog = rowData;
    this.logger.debug("rowData",rowData);
    this.isVisible = true;
    this.severity = this.messageUtil.convertMsg('Severity', this.detailLog.severity);
    this.message = this.messageUtil.convertMessage(this.detailLog.message);
    this.result = this.messageUtil.convertResult(this.detailLog);
    this.sourceType = this.messageUtil.convertMsg('SourceType', this.detailLog.sourceType);
    this.status = this.messageUtil.convertStatus(this.detailLog, "popup");
  }
  statusIssue (rowData) {
    let status = rowData.status;
    if(status == "OPENED") {
      if (rowData.logClass != null && rowData.logClass !== "") {
        this.handleSimpleIssue(rowData.logClass.code, rowData.id);
      }
    } else if(status == "FIXED") {
      let issueId = rowData.id;
      this.service.closeIssue(issueId).subscribe(
          value => {
            this.getMdmLogList(this.curPage,this.pageMax,this.searchText, this.searchId, this.sDate, this.eDate);
          },
          error=>{this.logger.error("-- error : " + error);},
          ()=>{}
      )
    }
  }

  private handleSimpleIssue (code, issueID) {
    this.issuedTitle = this.translate.instant("SecurityIssueAlert_Title");
    this.isIssuedVisible = true;
    this.issueID = issueID;
    this.issueMessage = this.translate.instant("ISSUE_SOLVE_"+code);

  }

  okAction () {
    this.isIssuedVisible = false;
    this.service.fixedIssue(this.issueID).subscribe(
      value => {
          this.getMdmLogList(this.curPage,this.pageMax,this.searchText, this.searchId, this.sDate, this.eDate);
        },
        error=>{this.logger.error("-- error : " + error);},
        ()=>{}
    )

  }

  cancleAction () {
    this.isIssuedVisible = false;
  }

}

@NgModule({
  imports: [DataTableModule, SharedModule, CommonModule,PaginatorModule,DropdownModule,InputTextModule,BrowserModule,HttpModule,FormsModule, SearchDropBoxModule, MainPipeMoudle, ButtonModule, ExDialogModule, PanelModule, TranslatePipeMoudle, LogConvertPipeMoudle],
  exports: [HeartBeatLogComponent],
  declarations: [HeartBeatLogComponent],
  providers: [MamAdminService],
})
export class HeartBeatLogModule {
}



// WEBPACK FOOTER //
// C:/Users/sung/WebstormProjects/exafe front/src/app/page/log/heartbeat_log.ts